import React, { useState, useEffect } from 'react'
import Urls from '../api/Urls';
import { useNavigate } from 'react-router-dom';

const AllAlumni = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [alumni, setAlumni] = useState([]);
    const [year, setYear] = useState("all");
    const [years, setYears] = useState([]);
    const [course, setCourse] = useState("all");
    const [empty, setEmpty] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [view, setView] = useState();

    /* 🔹 Pagination states */
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 30;

    useEffect(() => {
        window.scrollTo(0, 0);
        const current_year = new Date().getFullYear();
        let yrs = [];
        for (let i = current_year; i >= 1980; i--) {
            yrs.push(i);
        }
        setYears(yrs);
    }, []);

    useEffect(() => {
        const getAlumni = async () => {
            setLoading(true);
            try {
                let res = await fetch(Urls.SERVER + Urls.GET_ALL_ALUMNI, {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        year: year,
                        course: course,
                    }),
                });

                let resJson = await res.json();

                if (res.status === 200) {
                    if (resJson.alumni === "Empty") {
                        setEmpty(true);
                        setAlumni([]);
                    } else {
                        setView(resJson.view);
                        setAlumni(resJson.alumni);
                        setEmpty(false);
                        setCurrentPage(1); 
                    }
                }
            } catch (err) {
                console.log(err);
            }
            setLoading(false);
        };

        getAlumni();
    }, [year, course]);

    const goToAlumniDetails = (alumni_id) => {
        navigate('/alumni-details', {
            state: { alumni_id }
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/search-alumni', {
            state: { query: searchQuery }
        });
    };


    const totalPages = Math.ceil(alumni.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentAlumni = alumni.slice(startIndex, startIndex + itemsPerPage);

    return (
        <div className='container p-3 all-alumni'>
            {loading ? (
                <div className='row'>
                    <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '70vh' }}>
                        <div className="spinner-border" />
                    </div>
                </div>
            ) : (
                <div className='row'>
                    <div className='col-sm-12 my-3'>
                        <div className='d-flex justify-content-between flex-wrap'>
                            <form className='search-alumni' onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    placeholder="Search Alumni"
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </form>

                            <div className='filters'>
                                <span>Filter By</span>

                                <select onChange={(e) => setCourse(e.target.value)}>
                                    <option value="all">All Courses</option>
                                    <option value="MCA">MCA</option>
                                    <option value="BCA">BCA</option>
                                    <option value="BSc IT">BSc IT</option>
                                    <option value="PGDCA">PGDCA</option>
                                    <option value="PhD">PhD</option>
                                </select>

                                <select onChange={(e) => setYear(e.target.value)}>
                                    <option value="all">All Years</option>
                                    {years.map((y) => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <hr />
                    </div>

                    {empty ? (
                        <div className='empty text-center'>
                            <img src={require('../assets/img/empty.png')} alt="Empty" />
                            <h6>No Records Found!</h6>
                        </div>
                    ) : (
                        <>
                            <div className='allAlumniRow'>
                                {currentAlumni.map((alumni, index) => (
                                    <div className='alumni-card-main' key={index}>
                                        <div
                                            className="card shadow alumni-card"
                                            onClick={() => goToAlumniDetails(alumni.alumni_id)}
                                        >
                                            <img
                                                src={Urls.IMAGE + alumni.image}
                                                className="card-img-top"
                                                alt="Alumni"
                                            />
                                            <div className="card-body">
                                                <h5>
                                                    {alumni.firstname} {alumni.middlename} {alumni.lastname}
                                                </h5>
                                                {view === "1" ? (
                                                    <p>
                                                        {alumni.courses.map((c, i) => (
                                                            <span key={i}>{c} </span>
                                                        ))}
                                                    </p>
                                                ) : (
                                                    <p>{alumni.course} - {alumni.year_of_passing}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {totalPages > 1 && (
                                <div className="pagination-wrapper">
                                    <button
                                        className="page-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => setCurrentPage(prev => prev - 1)}
                                    >
                                        ‹
                                    </button>

                                    {[...Array(totalPages)].map((_, index) => {
                                        const page = index + 1;
                                        return (
                                            <button
                                                key={page}
                                                className={`page-btn ${currentPage === page ? 'active' : ''}`}
                                                onClick={() => setCurrentPage(page)}
                                            >
                                                {page}
                                            </button>
                                        );
                                    })}

                                    <button
                                        className="page-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => setCurrentPage(prev => prev + 1)}
                                    >
                                        ›
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default AllAlumni;
